import React, { useState, useEffect, useRef } from "react";

import Modal from "core/Modal";
import AttributionForm from "core/AttributionForm";
import { BlueBorderBottomLink } from "core/Typography";

import { useAttributionBacklink } from "icons/AttributionBacklink/Context";

import { ccbyLicenseLink } from "./data";

const AttributionAreaBasicNonDesktop = () => {
    const {
        downloadCount,
        startThankYouAnimation,
        resetAttributionCopy,
        attributionCopied
    } = useAttributionBacklink();

    const [modalIsOpen, setModalIsOpen] = useState(false);

    const prevDownloadCount = useRef(0);
    useEffect(() => {
        if (downloadCount > prevDownloadCount.current) {
            resetAttributionCopy();
            setModalIsOpen(true);
        }
        prevDownloadCount.current = downloadCount;
    }, [downloadCount]);

    const handleModalClose = () => {
        setModalIsOpen(false);
        attributionCopied && startThankYouAnimation();
    };

    return (
        <Modal
            open={modalIsOpen}
            handleClose={handleModalClose}
            heading="You must attribute the artist"
        >
            <p>
                Attributing the creator is required per{" "}
                <BlueBorderBottomLink href={ccbyLicenseLink} target="_blank">
                    CCBY license
                </BlueBorderBottomLink>
                . For print, product, and more usage information,{" "}
                <BlueBorderBottomLink
                    href="https://thenounproject.zendesk.com/hc/en-us/articles/200509948-Medium-Specific-Credit-Requirements-Examples"
                    target="_blank"
                >
                    see FAQ
                </BlueBorderBottomLink>
                .
            </p>
            <br />
            <p>Insert link below for digital uses.</p>
            <AttributionForm />
        </Modal>
    );
};

export default AttributionAreaBasicNonDesktop;
